import React from "react";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="notFound">
      <div>
        <h1>404</h1>
        <h5>Page not found please search the correct one!!!</h5>
      </div>
    </div>
  );
};

export default NotFound;
